<template>
    <div class="report-role-play-container">
        <organization-breadcrumb :items="[getCurrentClass.name, $t('ai_tutor.role_play_log'), $t('ai_tutor.report_role_play.title')]" />
        <div class="report-role-play-page">
            <el-row type="flex" justify="center">
                <el-col :xs="24" :md="14">
                    <router-link :to="{name: 'class-details', hash: '#airoleplaylog'}" class="back"><i class="el-icon-back"></i>Back</router-link>
                    <h1 class="blue-color" style="text-align: center">{{ $t('ai_tutor.report_role_play.title') }}</h1>
                    <div class="base-create">
                        <div class="base-create-body">
                            <el-form :model="form">
                                <elsa-input class="sender" :disabled="true" v-model="form.sender" :label="$t('ai_tutor.report_role_play.sender')" />
                                <elsa-input :disabled="true" v-model="form.subject" :label="$t('ai_tutor.report_role_play.subject')" />
                                <elsa-input-area v-model="form.describe" :label="$t('ai_tutor.report_role_play.describe')"
                                class="content-input-textarea" name="text" type="textarea" size="large" resize="none" :rows="10"
                                :style="{ border: 'none' }" />
                                <div>
                                    <label class="el-form-item__label">{{ $t('ai_tutor.report_role_play.attachment') }}:</label>
                                    <label class="el-form-item__value">{{ conversationReport.conversation_id }}.csv</label>
                                </div>
                            </el-form>
                        </div>
                        <div class="base-create-footer flex">
                            <primary-button v-loading.fullscreen.lock="loading" @click.native="sendReportRolePlay()">
                                {{ $t('common.send') }}
                            </primary-button>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ElsaInput from '@/components/common/Input'
import ElsaInputArea from '@/components/common/InputArea'
import OrganizationBreadcrumb from '@/components/common/OrganizationBreadcrumb'
import PrimaryButton from '@/components/common/buttons/PrimaryButton.vue'
import { successMessage, warningMessage } from '@/utils/messages'

export default {
    components: {
        ElsaInput,
        ElsaInputArea,
        OrganizationBreadcrumb,
        PrimaryButton,
    },
    data() {
        return {
            form: {
                sender: "",
                subject: "",
                describe: "",
            },
            rules: {
            },
            loading: false,
        }
    },
    computed: {
        ...mapGetters({
            getCurrentClass: 'classes/getCurrentClass',
            currentOrganization: "organization/currentOrganization",
            getUser: "user/getUser",
        }),
        conversationReport() {
            return this.$store.state.classes.aiConversationReport;
        },
    },
    methods: {
        sendReportRolePlay() {
            this.loading = true;
            const url = `v1/groups/${this.getCurrentClass.id}/role-play-conversation/${this.conversationReport.conversation_id}/report-issue`;
            this.$axios.post(url, this.form).then((response) => {
                this.loading = false;
                successMessage(this.$t('ai_tutor.report_role_play.success'))(this);
                return this.$router.push({
                    name: "class-details",
                    params: {
                        organizationId: this.currentOrganization.id,
                        groupId: this.getCurrentClass.id,
                    },
                    hash: "#airoleplaylog",
                });
            }).catch((error) => {
                this.loading = false;
                warningMessage(this.$t('ai_tutor.report_role_play.warning'))(this);
                throw error;
            });
        },
    },
    mounted() {
        if(this.conversationReport.conversation_id) {
            this.form.sender = this.getUser.email;
            const conversation_id = this.conversationReport.conversation_id;
            const subject = this.currentOrganization.name + " - " + this.getCurrentClass.name + " - AI Role-play Issue - " + conversation_id;
            this.form.subject = subject;
            const user_id_str = "User ID: " + this.conversationReport.user_id;
            const scenario_id_str = "Scenario ID: " + this.conversationReport.scenario_id;
            const conversation_id_str = "Conversation ID: " + this.conversationReport.conversation_id;
            const head_line = "\n\n\n\n\n\n-------Please do not the information below this line-------";
            this.form.describe = head_line + "\n" + user_id_str + "\n" + scenario_id_str + "\n" + conversation_id_str;
        }
    },
}
</script>
<style lang="scss" scoped>
.report-role-play-container {
    width: 100%;
}
.report-role-play-page {
    margin: 24px;
    h1 {
        border: 0;
        font-size: 30px;
        line-height: 45px;
        font-weight: 700;
    }
}
.el-form {
  padding-bottom: 0px !important;
}
.form-row {
  margin-top: 20px;
}
::v-deep .el-form-item__label {
  line-height: 24px !important;
  font-weight: 600 !important;
  color:#121131 !important;
}
.el-form-item__value {
  vertical-align: middle !important;
  font-style: italic;
  opacity: 0.5;
}
.base-create-footer {
    width: 100%;
    padding-top: 30px;
}
::v-deep .el-form-item.elsa-input .el-input {
    border: 1px solid #e6e6e6;
    height: 52px;
    border-radius: 8px;
    padding: 0 10px;
  .el-input__inner {
    background: #ccc !important;
    width: 100%;
    margin: auto;
    height: 35px;
    font-weight: bold;
    opacity: 0.8;
  }
}
::v-deep .elsa-input.sender {
    .el-input__inner {
        width: auto !important;
        margin-left: inherit !important;
        
    }
}
</style>
